import { ArrowUpRight } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGES } from 'routes';

export const PaymentMethodsCountry = ({
  setSelectedCurrency,
  id,
  country,
  flagCode,
  currencyCode,
  status,
  allowMmDeposit,
  allowMmWithdraw,
  allowManualBankDeposit,
  allowManualBankWithdraw,
  allowMerchantPay,
  allowTransfer,
  allowExchange,
  setIsDrawerOpen,
}) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => {
        setSelectedCurrency({
          id,
          country,
          flagCode,
          currencyCode,
          status,
          allowMmDeposit,
          allowMmWithdraw,
          allowManualBankDeposit,
          allowManualBankWithdraw,
          allowExchange,
          allowTransfer,
          allowMerchantPay,
        });
        setIsDrawerOpen(true);
      }}
      className="w-full p-4 bg-white/10 dark:bg-white/10 backdrop-blur-md rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 flex justify-between items-center text-white"
    >
      {/* Left Section: Country Info */}
      <div className="flex flex-col items-start justify-start">
        <h3 className="text-base font-semibold mb-1">
          {country} ({currencyCode})
        </h3>

        <span
          className={`inline-block font-bold mt-2 px-2 py-0.5 text-xs  rounded-md ${
            status === 1
              ? 'bg-green-500/10 text-white/80'
              : 'bg-red-500/10 text-red-400'
          }`}
        >
          {status === 1 ? 'Active' : 'Inactive'}
        </span>
      </div>

      {/* Right Section: Action + Flag */}
      <div className="flex flex-col items-end space-y-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/app/finance/${id}?previous_page=${PAGES.finance}&active_tab=payment_methods&payment_method=withdraw`
            );
          }}
          className="flex items-center space-x-1 text-xs "
        >
          <ArrowUpRight size={14} className="text-white/70" />
          <span className=" text-white/70">Preview</span>
        </button>
        <img
          src={`https://flagcdn.com/w40/${flagCode.toLowerCase()}.png`}
          alt={country}
          className="w-10 h-10 rounded-full shadow-sm"
        />
      </div>
    </button>
  );
};
